import '../../styles-new/pages/converter-page.scss';

import {currencyConverter} from '../components/currencies/converter';
import {currenciesDateSelector} from '../components/currencies/dateSelector';

 const url = new URL(window.location.href);
  url.searchParams.delete('date');
  url.searchParams.delete('bank');
  window.history.pushState({}, '', url);

currenciesDateSelector(() => {
  currencyConverter.convert({ preventDefault: () => {} })
});

const tabs = document.querySelectorAll('.currencies__rates_tabs_item');

const activeBank = url.searchParams.get('bank');

if(activeBank === 'national') {
  const [internationalTab, nationalTab] = tabs;
  internationalTab.classList.remove('tabs__item_active');
   nationalTab.classList.add('tabs__item_active')
}

/*
* Currencies dropdown elements
*/

const form = document.querySelector('.converter-block__form');
const dropdownFirstEl = form.querySelector('#first-currency-dropdown');
const dropdownSecondEl = form.querySelector('#second-currency-dropdown');
const dropdownBtnFirstEl = dropdownFirstEl.querySelector('.converter-dropdown__btn');
const dropdownBtnSecondEl = dropdownSecondEl.querySelector('.converter-dropdown__btn');
const firstDropdownContent = dropdownFirstEl.querySelector('#first-dropdown-content');
const secondDropdownContent = dropdownSecondEl.querySelector('#second-dropdown-content');

let [selectedCurrencyFirst,
  selectedCurrencySecond] = [
    {
      label: dropdownBtnFirstEl.textContent,
      value: dropdownBtnFirstEl.dataset.value
    },
    {
      label: dropdownBtnSecondEl.textContent,
      value: dropdownBtnSecondEl.dataset.value
    },
  ];

dropdownBtnFirstEl.addEventListener('click', () => {
  firstDropdownContent.classList.toggle('converter-dropdown__content_active');
});

dropdownBtnSecondEl.addEventListener('click', () => {
  secondDropdownContent.classList.toggle('converter-dropdown__content_active');
});

const handleCurrencyChange = (e, rank) => {
  const el = e.target.closest('.converter-dropdown__item');
  const value = el.dataset?.value;
  const flagIcon = el.querySelector('.converter-dropdown__flag')?.cloneNode(true);

  if (value) {
    if (rank === 'first') {
      selectedCurrencyFirst = { value, label: el.textContent };
      firstDropdownContent.classList.remove('converter-dropdown__content_active');
      const fromCurrency = dropdownBtnFirstEl.querySelector('#from-currency');
      fromCurrency.innerHTML = selectedCurrencyFirst.label;
      dropdownBtnFirstEl.dataset.value = selectedCurrencyFirst.value;
      fromCurrency.dataset.value = selectedCurrencyFirst.value;

      if(flagIcon) {
        fromCurrency.prepend(flagIcon)
      }
    } else {
      selectedCurrencySecond = { value, label: el.textContent };
      secondDropdownContent.classList.remove('converter-dropdown__content_active');
      const toCurrency = dropdownBtnSecondEl.querySelector('#to-currency');
      toCurrency.innerHTML = selectedCurrencySecond.label;
      dropdownBtnSecondEl.dataset.value = selectedCurrencySecond.value;
      toCurrency.dataset.value = selectedCurrencySecond.value;
      if(flagIcon) {
        toCurrency.prepend(flagIcon)
      }
    }
    currencyConverter.convert({ preventDefault: () => {} })
  }
}

// on list-item-click
firstDropdownContent.addEventListener('click', (e) => handleCurrencyChange(e, 'first'));
secondDropdownContent.addEventListener('click', (e) => handleCurrencyChange(e, 'second'));

// click outside of the currency-dropdown
document.addEventListener('click', (e) => {
  const el = e.target;

  if (!dropdownFirstEl.contains(el)) {
    firstDropdownContent.classList.remove('converter-dropdown__content_active');
  }

  if (!dropdownSecondEl.contains(el)) {
    secondDropdownContent.classList.remove('converter-dropdown__content_active');
  }
});

/////////////////////////////////////////////////////////

/*
* Swap currencies button
*/

// const [firstInput, secondInput] = [form.querySelector('input[name="first"]'), form.querySelector('input[name="second"]')];

// form.addEventListener('submit', (e) => {
//     e.preventDefault();
//     const firstInputValue = firstInput.value;
//     const secondInputValue = secondInput.value;
//     // TODO: Conversion itself
//     firstInput.value = secondInputValue;
//     secondInput.value = firstInputValue;
// })

/////////////////////////////////////////////////////////